<mat-form-field>
  <mat-label>{{ label | transloco }}</mat-label>
  <mat-select [panelClass]="panelClasses" [panelWidth]="panelWidth" [formControl]="itemFormControl" [compareWith]="compareWith"
    disableOptionCentering [multiple]="multiple">
    <mat-select-trigger>
      <span class="mat-mdc-select-min-line">{{ selectedItemsFormatted }}</span>
    </mat-select-trigger>
    <div class="search-selectall">
      <div class="search-input">
        <input type="text" name="search" class="mat-select-search-input"
          placeholder="{{ 'common.buttons.search' | transloco }}" [formControl]="searchFormControl" autocomplete="off"
          (keydown)="$event.stopPropagation()"/>
        <button mat-icon-button (click)="searchFormControl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-option *ngIf="multiple" [value]="selectAllValue" (click)="onSelectAllClicked()">{{ 'common.buttons.selectAll' | transloco
        }}</mat-option>
      <mat-option *ngIf="!multiple">{{ 'common.text.noSelection' | transloco }}</mat-option>
      <mat-divider></mat-divider>
    </div>
    <ng-container *ngIf="filteredItems.length > 0; else noResults">
      <mat-option [class.app-invisible-mat-option]="!filteredItems.includes(item)" *ngFor="let item of itemsToSelect"
        [value]="item" (click)="emitItems()">{{ getOptionName(item) }}
      </mat-option>
    </ng-container>
    <ng-template #noResults>
      <mat-optgroup>
        <div>{{ 'common.text.noResults' | transloco }}</div>
      </mat-optgroup>
    </ng-template>
  </mat-select>
</mat-form-field>
